import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';
import { isGreaterThanBreakpoint } from 'dpl/util/grid';

import glassesIllustration from 'dpl/assets/fetch_glasses.png';

const IS_GT_MD = isGreaterThanBreakpoint('md');

export default function BuyerApplicationPostRegistration({
  onNextClick,
  canAdvance,
  breederProfile
}) {
  const { first_name: breederFirstName } = breederProfile;

  return (
    <div className={SECTION_CLASSES}>
      <div className="FullPageQuizQuestion tc">
        <div className="mb8 flex justify-center">
          <SmartImage
            Tag="div"
            width="108px"
            height="99px"
            lazy
            className="bg-center cover h-100 w-100"
            loadingClass="bg-light-gray br-100"
            src={glassesIllustration}
          />
        </div>
        <h3 className="f4 f6-md lh-title mb4">
          We let {breederFirstName} know you&apos;re interested.
        </h3>
        <p className="secondary font-16-mobile mb14">
          Continue to the next step to learn more and get to know each other
          better.
        </p>
        {IS_GT_MD && (
          <button
            type="button"
            onClick={onNextClick}
            className="pv3 mt3 mb2 inline-flex fw-medium w-100 justify-center bg-royal-blue white b--royal-blue br2 ph4 font-16"
            disabled={!canAdvance}
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}

BuyerApplicationPostRegistration.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  canAdvance: PropTypes.bool.isRequired,
  breederProfile: PropTypes.shape({
    first_name: PropTypes.string
  }).isRequired
};
